var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { ItemBase } from '../../models/item/item-base';
var ListDirective = /** @class */ (function (_super) {
    __extends(ListDirective, _super);
    function ListDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        return _this;
    }
    ListDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ListDirective.prototype.onInit = function () {
        _super.prototype.onInit.call(this);
        if (this.tag === 'td') {
            if (this.checkBtn(this.col)) {
                _super.prototype.addClass.call(this, 'tableWrapper_buttonTd');
            }
            if (this.col.params && this.col.params.ellipsis) {
                _super.prototype.addClass.call(this, 'tableWrapper_ellipsisTd-w' + this.col.params.ellipsis);
            }
        }
        var add = jsonpath.value(this.col, '$.params.addClass.' + this.tag);
        if (add) {
            _super.prototype.addClass.call(this, add);
        }
    };
    ListDirective.prototype.checkBtn = function (col) {
        var check = false;
        if (col.controlType === 'button') {
            check = true;
        }
        if (col.items) {
            for (var _i = 0, _a = col.items; _i < _a.length; _i++) {
                var item = _a[_i];
                check = this.checkBtn(item);
                if (check) {
                    break;
                }
            }
        }
        return check;
    };
    ListDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[listDir]'
                },] }
    ];
    /** @nocollapse */
    ListDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    ListDirective.propDecorators = {
        col: [{ type: Input }]
    };
    return ListDirective;
}(ClassBaseDirective));
export { ListDirective };
//# sourceMappingURL=list.directive.js.map